import React from "react";
import { useDispatch } from "react-redux";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import GlobalStyle from "./GlobalStyle";

import Nows from "Components/Pages/Nows";
import NowContents from "Components/Pages/NowContents";

import * as actions from "actions";

function Master() {
   const dispatch = useDispatch();

   function onResize() {
      dispatch({
         type: actions.dimensions.sync,
         payload: {
            width: window.innerWidth,
            height: window.innerHeight,
         },
      });
   }

   window.addEventListener("resize", onResize);

   return (
      <Router>
         <GlobalStyle></GlobalStyle>
         {/* <Header /> */}
         <Routes>
            <Route path="/nows/:now_id.html" element={<NowContents />}></Route>
            <Route path="/nows/:now_id" element={<NowContents />}></Route>
            <Route path="/nows/:now_id/:uri_title" element={<NowContents />}></Route>
            <Route path="/nows" element={<Nows />}></Route>
            {/* <Route path="/" element={<PageDashboard />} /> */}
            {/* <Route path="*" element={<PageDashboard />} /> */}
         </Routes>
         {/* {footer} */}
      </Router>
   );
}

export default Master;
